import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-ui-bom-copy-to-button',
    templateUrl: './bom-copy-to-button.component.html',
    styleUrls: ['./bom-copy-to-button.component.scss'],
    standalone: false
})
export class BomCopyToButtonComponent {

  @Input() selectedItemsCount: number;

  @Output() copyButtonClicked = new EventEmitter();

  buttonClicked() {
    this.copyButtonClicked.emit();
  }
}
